import shave from 'shave';

export default class eventCalloutCard {
  constructor(el) {
    this.el = el;
    this.eventTitle = this.el.querySelector('[events-callout-slide-title]');
    this.init();
  }

  init() {
    this.truncateEventTitle(this.eventTitle);

    setTimeout(() => {
      this.truncateEventTitle(this.eventTitle);
    }, 2000);
  }

  truncateEventTitle(eventTitle) {
    shave(eventTitle, 100);
  }
}
